import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import { ICDEKOffice, IGetCDEKOffices } from 'models/cdek'

export const cdekApi = {
  getPvzPoints({ city }: IGetCDEKOffices): Promise<AxiosResponse<ICDEKOffice[]>> {
    return privateApi.get<ICDEKOffice[]>(`cdek?city=${city}`)
  },
  // По координатам бэкенд отдаёт регион ближайшего пункта целиком. По названию города
  // искать ненадёжно: при несовпадении написания он молча возвращает всю страну
  getPvzPointsByCoords(lat: number, lon: number): Promise<AxiosResponse<ICDEKOffice[]>> {
    return privateApi.get<ICDEKOffice[]>('cdek', { params: { lat, lon } })
  }
}
